import React from 'react';
import { useRecordContext, Link } from 'react-admin';

// Renders the current record's own field and links to its show page.
// Useful inside an ArrayField/Datagrid where each row IS the entity.
const SelfLinkField = ({ source = 'name', resource, link = true, ...props }) => {
  const record = useRecordContext();
  if (!record) return null;
  const display = record[source] ?? record.id ?? record.external_id ?? '—';
  if (link && resource && (record.id != null || record.external_id != null)) {
    const id = record.id ?? record.external_id;
    return (
      <Link to={`/${resource}/${id}/show`} {...props}>
        {display}
      </Link>
    );
  }
  return <span {...props}>{display}</span>;
};

export default SelfLinkField;
